import { PropertyValue } from "src/context/Property/Builder/PropertyBuilder";
import { Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { deserializeReadOnly } from "src/context/Property/PropertyValueSerializer";

type DisplayValueProps = {
    withTitle?: boolean;
    property: PropertyValue;
};
export const DisplayValue = (props: DisplayValueProps) => {
    const { withTitle = false, property } = props;
    const theme = useTheme();

    return (
        <Stack
            padding={theme.spacing(4)}
            gap={theme.spacing(2)}
            justifyContent={"center"}
            alignItems={"left"}
            height={"100%"}
            sx={{ backgroundColor: theme.custom.grey[200] }}
        >
            {withTitle === true && <Typography variant="big-bold">{property.property.title}</Typography>}
            <Stack flexDirection={"row"} gap={theme.spacing(2)} alignItems={"center"}>
                <ValueLine property={property} />
            </Stack>
        </Stack>
    );
};

type ValueLineProps = {
    property: PropertyValue;
};
const ValueLine = (props: ValueLineProps) => {
    const { t } = useTranslation();
    const { property } = props;

    const isValueInvalid = property.value === "" || !property.value;
    const { labels } = deserializeReadOnly(property);

    if (isValueInvalid) {
        return <Typography variant="body-medium">{t("questionnaire.no_answer")}</Typography>;
    }

    return (
        <>
            <Typography variant={"huge-bold"}>{labels}</Typography>
            <Typography variant={"body-medium"}>{property.unit}</Typography>
        </>
    );
};
